<template>
    <div class="goods-purchase">
        <div class="goods-purchase-section goods-purchase-steps">
            <veui-steps :steps="steps" :current="current - 1"/>
        </div>
        <div class="goods-purchase-section goods-purchase-steps" style="padding: 24px;">
            <notice
                content="公告：亲爱的合作伙伴，因业务战略调整，律临2024年7月1日起全线会员商品停止售卖，涵盖会员及增值服务，律临团队将对已售会员继续提供服务保障支持以及产品端功能维护，感谢大家一直以来的理解和支持，后续律临将以新的产品形式和大家见面，敬请关注。"
            />
        </div>
        <div class="goods-purchase-section">
            <div
                v-if="current === 2"
                class="item-title"
            >购买{{ goodsList.name }}</div>
            <keep-alive>
                <component
                    :is="currentTabComponent.step"
                    :ref="currentTabComponent.step"
                    :goods-list="goodsList"
                    :goods-form="goodsForm"
                    :goods-order="goodsOrder"
                    :goods-info="goodsInfo"
                    :channel="lawFirmInfo.channel"
                    :can-buy-list="canBuyList"
                    v-bind="curComponentProps"
                    @nextStep="nextStep"
                    @setGoodsFn="setGoodsFn"
                    @handleCapitalPoolOrder="handleCapitalPoolOrder"
                ></component>
            </keep-alive>
        </div>
        <div class="goods-purchase-section">
            <!-- <div
                v-if="current === 2 && goodsForm.clue_count && goodsForm.clue_count < 50"
                class="goods-purchase-goods-price"
            >
                共{{goodsForm.clue_count}}个，合计支付：¥
                <span class="goods-purchase-goods-price-active">{{goodsForm.clue_count * 15}}</span>
            </div> -->
            <div>
                <veui-button
                    v-if="current > 1"
                    ui="m strong"
                    style="margin-left: 4px;"
                    @click="changeSteps(-1)"
                >
                    上一步
                </veui-button>
                <veui-button
                    class="goods-btn"
                    ui="m primary"
                    :loading="buttonLoading"
                    :disabled="+lawFirmInfo.dispatch_status === 1"
                    @click="handlePrimary"
                >
                    {{ currentTabComponent.button }}
                </veui-button>
            </div>
        </div>
        <veui-toast
            status="warning"
            :open="showToast"
            message="请选择商品类型"
            class="goods-purchase-toast"
        />
        <veui-confirm-box
            title="支付提示"
            :open.sync="confirmOpen"
            ok-label="确认支付"
            cancel-label="取消支付"
            @ok="confirmBuy"
            @cancel="cancelBuy"
        >
            <p>
                本次将从您的凤巢推广账户({{
                    lawFirmInfo.ucid
                }})扣款¥{{ goodsOrder.pay_amount / 100 }}元，请确认支付。
            </p>
        </veui-confirm-box>
        <veui-alert-box status="info" :open.sync="isBalanceShort">
            <template #title> 余额不足 </template>
            <div>
                余额：¥{{
                    lawFirmInfo.balance
                }}元。
            </div>
            <div>凤巢推广账户余额不足，请充值后重新下单支付。</div>
        </veui-alert-box>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 线索购买
 * @author
 */
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import {Steps, Button, Toast, ConfirmBox, AlertBox} from 'veui';
import goodsForm from './goodsForm';
import goodsFormMember from './goodsFormMember';
import goodsFormLight from './goodsFormLight';
import goodsFormExposure from './goodsFormExposure';
import goodsFormAddClue from './goodsFormAddClue';
import goodsFormYoung from './goodsFormYoung';
import goodsList from './goodsList';
import goodsOrder from './goodsOrder';
import toast from 'veui/plugins/toast';
import member from '../../../assets/img/law/member.png';
import vka from '../../../assets/img/law/vka.png';
import notice from '@/components/notice';
const url = {
    vipbuyprice: '/bp/firm/getbuyprice',
    buycode: 'law:/themis/law/commodity/vipbuycode',
    clueQuerySelect: 'law:/themis/law/commodity/clue_queryselect'
};
Vue.use(toast);
export default {
    name: 'goodsPurchase',
    data() {
        return {
            steps: [
                {label: '选择商品类型', desc: ''},
                {label: '购买商品', desc: ''},
                {label: '确认订单', desc: ''}
            ],
            current: 1,
            buttonLoading: false,
            showToast: false,
            doaminOption: [],
            regionOption: [],
            timeOption: [],
            agreementInfoClue: {},
            agreementInfoMember: {},
            agreementInfoExposure: {},
            agreementInfoYoung: {},
            agreementInfoAddClue: {},
            agreementInfoLawFirm: {},
            goodsList: {},
            goodsForm: {},
            goodsOrder: {},
            goodsInfo: {},
            // 可购买信息
            canBuyList: [],
            confirmOpen: false,
            formData: {},
            isBalanceShort: false
        };
    },
    mounted() {
        this.getClueQuerySelect();
        this.getagreement();
        this.getPrice();
        if (this.$route.query.orderId && this.$route.query.goodsId === '3') {
            this.current = 2;
            this.goodsList = {
                name: '尊享会员',
                goodsId: '3',
                icon: member,
                comp: 'goodsFormMember'
            };
        }
        else if (
            this.$route.query.orderId
            && this.$route.query.goodsId === '6'
        ) {
            this.current = 2;
            this.goodsList = {
                name: '律临V卡',
                goodsId: '6',
                icon: vka,
                comp: 'goodsFormLight'
            };
        }
        const newTabData = JSON.parse(sessionStorage.getItem('newTabData'));
        if (newTabData) {
            this.current += 1;
            this.goodsList = newTabData.goodsList;
            this.steps[1].label = `购买${this.goodsList.name}`;
            // 流程修改--只第一次打开新页面时-展示，刷新页面重置, pm：liangrui
            sessionStorage.removeItem('newTabData');
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.lawStore.userInfoNew,
            lawFirmInfo: state => state.lawStore.userInfoNew.law_firm_info
                || state.lawStore.userInfoNew.law_firm_subaccount || {}
        }),
        currentTabComponent() {
            const map = {
                1: {step: 'goodsList', button: '下一步'},
                2: {
                    step: this.goodsList.comp || 'goodsForm',
                    button: '提交订单'
                },
                3: {step: 'goodsOrder', button: '去支付'}
            };
            return map[this.current];
        },
        curComponentProps() {
            return this.goodsList.comp === 'goodsForm'
                ? {
                    doaminOption: this.doaminOption, // 线索领域
                    regionOption: this.regionOption, // 线索地域
                    timeOption: this.timeOption, // 线索时效
                    agreementInfo: this.agreementInfoClue
                }
                : this.goodsList.comp === 'goodsFormExposure'
                    ? {
                        agreementInfo: this.agreementInfoExposure
                    }
                    : this.goodsList.comp === 'goodsFormYoung'
                        ? {
                            agreementInfo: this.agreementInfoYoung
                        }
                        : this.goodsList.comp === 'goodsFormAddClue'
                            ? {
                                agreementInfo: this.agreementInfoAddClue
                            }
                            // 律所会员
                            : this.goodsList.comp === 'goodsFormMember' && +this.goodsList.goodsId === 7
                                ? {
                                    agreementInfo: this.agreementInfoLawFirm
                                }
                                : {
                                    agreementInfo: this.agreementInfoMember
                                };
        }
    },
    components: {
        'veui-confirm-box': ConfirmBox,
        'veui-alert-box': AlertBox,
        'veui-steps': Steps,
        'veui-button': Button,
        'veui-toast': Toast,
        goodsList,
        goodsForm,
        goodsOrder,
        goodsFormMember,
        goodsFormLight,
        goodsFormExposure,
        goodsFormAddClue,
        goodsFormYoung,
        notice
    },
    methods: {
        ...mapActions({
            getLawAgreement: 'lawStore/getLawAgreement'
        }),

        /**
         * 确认支付
         */

        confirmBuy() {
            this.buttonLoading = true;
            let postParams = {
                buy_time: '' + Math.round(new Date().getTime() / 1000), // 下单时间
                num: this.formData.num, // 购买数量
                agreement_ids: this.curComponentProps.agreementInfo.id // 协议id
            };
            // 律临会员
            // 律临尊享会员 code_type 0,所以不用传
            if (+this.goodsList.goodsId === 3) {
                postParams = {
                    ...postParams,
                    city_level: this.formData.city_level,
                    domain_fields_num: this.formData.domain_fields_num || 0
                };
            }
            // v卡
            else if (+this.goodsList.goodsId === 6) {
                postParams = {
                    ...postParams,
                    vip_duration: this.formData.vip_duration,
                    code_type: 1
                };
            }
            // 律所会员
            else if (+this.goodsList.goodsId === 7) {
                postParams = {
                    ...postParams,
                    city_level: this.formData.city_level,
                    domain_fields_num: this.formData.domain_fields_num || 0,
                    code_type: 3
                };
            }
            // 启航会员
            else if (+this.goodsList.goodsId === 2000) {
                postParams = {
                    ...postParams,
                    code_type: 7
                };
            }
            // 精英会员
            else if (+this.goodsList.goodsId === 2001) {
                postParams = {
                    ...postParams,
                    city_level: this.formData.city_level,
                    domain_fields_num: this.formData.domain_fields_num || 0,
                    code_type: 8
                };
            }
            this.$http
                .post(url.buycode, {
                    ...postParams
                })
                .then(resp => {
                    const data = this.$normalizeResponseData(resp);
                    if (data) {
                        this.$toast.success('购买成功，5分钟后生成对应会员码');
                        this.$router.push({name: 'clueSuccess'});
                    }
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                })
                .finally(() => {
                    this.buttonLoading = false;
                });
        },
        getPrice() {
            this.$http
                .get(url.vipbuyprice)
                .then(res => {
                    if (res && res.data) {
                        const {can_buy, goods} = res.data;
                        this.goodsInfo = goods || {};
                        this.canBuyList = can_buy || [];
                    }
                })
                .catch(err => this.$normalizeResponseError(err));
        },
        handleClick(index, event) {
            this.current = index + 1;
        },
        handlePrimary() {
            switch (this.current) {
                case 1: {
                    if (!this.goodsList.goodsId) {
                        this.showToast = true;
                        setTimeout(() => {
                            this.showToast = false;
                        }, 2000);
                    }
                    else {
                        const {href} = this.$router.resolve({
                            name: 'goodsPurchase'
                        });
                        const params = {
                            label: this.goodsList.name,
                            goodsList: this.goodsList
                        };
                        sessionStorage.setItem('newTabData', JSON.stringify(params));
                        window.open(href, '_blank');
                        sessionStorage.removeItem('newTabData');
                    }
                    break;
                }
                case 2: {
                    if (this.buttonLoading) {
                        return;
                    }
                    this.buttonLoading = true;
                    this.$refs[this.goodsList.comp].sumbitForm();
                    break;
                }
                case 3: {
                    const channel = this.lawFirmInfo.channel;
                    if (
                        channel === 1
                        && (+this.goodsList.goodsId === 3
                            || +this.goodsList.goodsId === 6
                            || +this.goodsList.goodsId === 7
                            || +this.goodsList.goodsId === 2000
                            || +this.goodsList.goodsId === 2001
                        )
                    ) {
                        this.handleCapitalPoolBuy();
                        return;
                    }
                    window.location.href = this.goodsOrder.pay_url;
                    break;
                }
            }
        },
        changeSteps(num) {
            this.current += num;
            if (this.current === 1) {
                this.steps[1].label = '购买商品';
            }
        },
        nextStep(value) {
            this.buttonLoading = false;
            if (value) {
                this.changeSteps(+1);
            }
        },
        getClueQuerySelect() {
            const params = {
                select_name: 'clue_territory,clue_city,clue_time',
                query_refer: 'lvlin_b'
            };
            this.$http
                .get(url.clueQuerySelect, {
                    params
                })
                .then(resp => {
                    const data = this.$normalizeResponseData(resp);
                    if (data) {
                        this.doaminOption = data.clue_territory;
                        this.regionOption = data.clue_city;
                        this.timeOption = data.clue_time;
                    }
                })
                .catch(err => this.$normalizeResponseError(err));
        },
        getagreement() {
            // 13 律所会员协议
            Promise.all([
                this.getLawAgreement({product_type: '6'}),
                this.getLawAgreement({product_type: '1'}),
                this.getLawAgreement({product_type: '8'}),
                this.getLawAgreement({product_type: '11'}),
                this.getLawAgreement({product_type: '12'}),
                this.getLawAgreement({product_type: '13'})
            ])
                .then(res => {
                    if (res[0]) {
                        this.agreementInfoClue = res[0][0] || {};
                    }
                    if (res[1]) {
                        this.agreementInfoMember = res[1][0] || {};
                    }
                    if (res[2]) {
                        this.agreementInfoExposure = res[2][0] || {};
                    }
                    if (res[3]) {
                        this.agreementInfoYoung = res[3][0] || {};
                    }
                    if (res[4]) {
                        this.agreementInfoAddClue = res[4][0] || {};
                    }
                    if (res[5]) {
                        this.agreementInfoLawFirm = res[5][0] || {};
                    }
                })
                .catch(err => this.$normalizeResponseError(err));
        },
        setGoodsFn(name, value) {
            this[name] = value;
        },
        handleCapitalPoolOrder() {
            // 如果账户是资金池账户，则在前端生成订单属性并展示
            this.buttonLoading = false;
            let formData = this.$refs[this.goodsList.comp].formData;
            this.formData = formData;
            formData.domain_fields_num = formData.domain_fields_num || 0;
            let order = null;
            this.changeSteps(+1);
            if (
                +this.goodsList.goodsId === 3
                || +this.goodsList.goodsId === 7
                || +this.goodsList.goodsId === 2001
            ) {
                // 律临会员订单属性处理或律所会员
                let curGoodsInfo = {};
                // 律所会员
                if (+this.goodsList.goodsId === 7) {
                    curGoodsInfo = this.goodsInfo?.business_vip || {};
                }
                // 尊享会员
                else if (+this.goodsList.goodsId === 3) {
                    curGoodsInfo = this.goodsInfo?.full_vip || {};
                }
                // 精英会员
                else if (+this.goodsList.goodsId === 2001) {
                    curGoodsInfo = this.goodsInfo?.elite_vip || {};
                }
                const cityPrice = curGoodsInfo.city?.[formData.city_level];
                const domainPrice = curGoodsInfo.domain?.[formData.city_level];
                const totalAmount
                    = cityPrice * formData.num
                    + domainPrice * formData.domain_fields_num; // eslint-disable-line
                const nameInfo = {
                    3: '尊享会员',
                    7: '至尊会员',
                    2001: '精英会员'
                };
                order = {
                    name: nameInfo[this.goodsList.goodsId] || '',
                    range: `一年卡(￥${cityPrice / 100}/个)`,
                    numTxt: `${formData.num}个`,
                    priceText: `￥${cityPrice / 100}/个`,
                    plusService: '领域标签',
                    domainFieldsNumTxt: `${formData.domain_fields_num}个`,
                    servicePrice: `￥${domainPrice / 100}/个`,
                    discountAmountTxt:
                        '-￥'
                        + (
                            (totalAmount * (1 - curGoodsInfo.discount / 10))
                            / 100
                        ).toFixed(0)
                        + `(${curGoodsInfo.discount}折优惠)`, // eslint-disable-line
                    pay_amount: (
                        totalAmount
                        * (curGoodsInfo.discount / 10)
                    ).toFixed(0),
                    domainFieldsNum: formData.domain_fields_num || 0,
                    num: formData.num || 0
                };
            }
            else if (+this.goodsList.goodsId === 6) {
                // 律临V卡订单属性处理
                const curGoodsInfo = this.goodsInfo.vcard_vip || {};
                const price = curGoodsInfo.expire?.[formData.vip_duration];
                const totalAmount = price * formData.num;
                order = {
                    name: '律临V卡',
                    range:
                        formData.vip_duration === 'full_year'
                            ? '一年卡'
                            : '半年卡',
                    numTxt: `${formData.num}个`,
                    discountAmountTxt:
                        '-￥'
                        + (
                            (totalAmount * (1 - curGoodsInfo.discount / 10))
                            / 100
                        ).toFixed(0)
                        + `(${curGoodsInfo.discount}折优惠)`, // eslint-disable-line
                    pay_amount: (
                        totalAmount
                        * (curGoodsInfo.discount / 10)
                    ).toFixed(0),
                    num: formData.num || 0
                };
            }
            else if (+this.goodsList.goodsId === 2000) {
                // 启航会员
                const curGoodsInfo = this.goodsInfo?.young_vip;
                const totalAmount = curGoodsInfo.price * formData.num;
                order = {
                    name: '启航会员',
                    range: '一年卡',
                    numTxt: `${formData.num}个`,
                    priceText: `￥${curGoodsInfo.price / 100}/个`,
                    servicePrice: `￥${curGoodsInfo.domain / 100}/个`,
                    discountAmountTxt:
                        curGoodsInfo.discount < 10
                            ? '-￥'
                                + (
                                    (totalAmount * (1 - curGoodsInfo.discount / 10))
                                    / 100
                                ).toFixed(0)
                                + `(${curGoodsInfo.discount}折优惠)`
                        : 'hidden', // eslint-disable-line
                    pay_amount: (
                        totalAmount
                        * (curGoodsInfo.discount / 10)
                    ).toFixed(0),
                    num: formData.num || 0
                };
            }
            else if (+this.goodsList.goodsId === 1000) {
                // 线索加购
                const curGoodsInfo = this.goodsInfo?.clue_quota;
                const totalAmount = curGoodsInfo.price * formData.num;
                order = {
                    name: '线索额外量',
                    lawyer: formData.lawyer_name,
                    qcCoreNo: formData.qc_core_no,
                    price: '¥' + curGoodsInfo.price,
                    shouldPayAmount: '¥' + totalAmount
                };
            }
            this.goodsOrder = order;
        },
        cancelBuy() {
            this.confirmOpen = false;
        },
        handleCapitalPoolBuy() {
            // 展开确认弹窗
            // 如果商品金额大于当前账户余额，则展示余额不足弹窗
            if (
                this.goodsOrder.pay_amount / 100
                > this.lawFirmInfo.balance
            ) {
                this.isBalanceShort = true;
                return;
            }
            this.confirmOpen = true;
        }
    }
};
</script>

<style scoped lang="stylus">
.goods-purchase {
    .goods-purchase-section {
        padding: 24px;
        margin-bottom: 24px;
        background: #fff;
        border-radius: 4px;

        .item-title {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #333;
            line-height: 16px;
            font-weight: 600;
            padding-bottom: 24px;
        }
    }

    .goods-purchase-steps {
        padding: 24px 190px;
    }

    .goods-purchase-goods-price {
        margin-bottom: 16px;
        font-size: 14px;
        color: #282c33;

        &-active {
            font-size: 24px;
            color: #272c34;
        }
    }
}

.goods-purchase-toast {
    position: fixed;
    top: 100px;
    left: 45%;
}

.goods-btn {
    margin-left: 10px;
}
</style>

